export default __webpack_public_path__ + "static/apple-touch-icon-12c418a7241620d6a77f55ffb559d98a.png";